<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营部</el-breadcrumb-item>
      <el-breadcrumb-item>培训师工作台</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- ========================================
         统计卡片区
         显示待完成和已完成的任务数量统计
    ======================================== -->
    <div class="statistics-row">
      <!-- 待完成任务统计卡片 -->
      <el-card class="stat-card" shadow="hover" @click.native="handleStatClick('todo')">
        <div class="stat-card-content">
          <div class="stat-icon wait-icon">
            <i class="el-icon-edit"></i>
          </div>
          <div class="stat-info">
            <div class="stat-number">{{ todoTotal }}</div>
            <div class="stat-label">待完成</div>
          </div>
        </div>
      </el-card>

      <!-- 已完成任务统计卡片 -->
      <el-card class="stat-card" shadow="hover" @click.native="handleStatClick('completed')">
        <div class="stat-card-content">
          <div class="stat-icon finish-icon">
            <i class="el-icon-circle-check"></i>
          </div>
          <div class="stat-info">
            <div class="stat-number">{{ completedTotal }}</div>
            <div class="stat-label">已完成</div>
          </div>
        </div>
      </el-card>
    </div>

    <!-- ========================================
         Tabs 列表区
         包含待完成和已完成两个Tab页
    ======================================== -->
    <el-card class="box-card" style="margin-top: 20px;">
      <el-tabs v-model="activeTab" type="card" @tab-click="handleTabChange">
        <!-- ==================== 待完成列表 Tab ==================== -->
        <el-tab-pane label="待完成" name="todo">
          <!-- 搜索栏 -->
          <div class="search-bar">
            <el-form :model="todoQuery" :inline="true" size="small" label-width="80px">
              <el-form-item label="关键字">
                <el-input
                  v-model="todoQuery.keyword"
                  placeholder="项目名称/客户名称"
                  clearable
                  @clear="getTodoList"
                  @keyup.enter.native="getTodoList"
                  style="width: 200px;">
                </el-input>
              </el-form-item>
              <el-form-item label="任务类型">
                <el-select
                  v-model="todoQuery.nodeCode"
                  placeholder="全部"
                  clearable
                  style="width: 150px;"
                  @change="getTodoList">
                  <el-option label="公司培训" value="COMPANY_TRAINING_COMPLETE"></el-option>
                  <el-option label="实操培训" value="PRACTICAL_TRAINING_COMPLETE"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="培训师">
                <el-select
                  v-model="todoQuery.trainerId"
                  placeholder="全部"
                  clearable
                  style="width: 150px;"
                  @change="getTodoList">
                  <el-option v-for="emp in employeeList" :key="emp._id" :label="emp.name" :value="emp._id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getTodoList">查询</el-button>
              </el-form-item>
            </el-form>
          </div>

          <!-- 待完成列表表格 -->
          <el-table :data="todoList" border stripe v-loading="todoLoading">
            <el-table-column type="index" label="#" width="50"></el-table-column>
            <el-table-column label="项目名称" min-width="200">
              <template slot-scope="scope">
                <div class="text-title">{{ scope.row.projectName || '-' }}</div>
                <div class="text-detail">{{ scope.row.customerName || '-' }}</div>
              </template>
            </el-table-column>
            <el-table-column label="预约时间" min-width="100">
              <template slot-scope="scope">
                {{ scope.row.startedAt | date }}
              </template>
            </el-table-column>
            <el-table-column label="签约人" min-width="100">
              <template slot-scope="scope">
                {{ scope.row.signerName || '-' }}
              </template>
            </el-table-column>
            <el-table-column label="签约品牌" min-width="100">
              <template slot-scope="scope">
                {{ scope.row.signType || '-' }}
              </template>
            </el-table-column>
            <el-table-column label="负责人" min-width="120">
              <template slot-scope="scope">
                <div class="text-content">
                  {{ scope.row.assigneeName || '-' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="任务类型" min-width="130">
              <template slot-scope="scope">
                <el-tag :type="scope.row.role === 'companyTrainer' ? 'primary' : 'success'" size="small">
                  {{ (scope.row.role === 'companyTrainer' ? '公司培训' : '实操培训') }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="任务进度" min-width="130">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === 'IN_PROGRESS' ? 'primary' : 'warning'" size="small">
                  {{ (scope.row.status === 'IN_PROGRESS' ? '待完成' : '待修改') }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column label="答题结果" min-width="150">
              <template slot-scope="scope">
                <template v-if="scope.row.projectId && (scope.row.role === 'companyTrainer' || scope.row.role === 'practicalTrainer') && examResults[scope.row.projectId + '_' + scope.row.role]">
                  <el-tag
                    :type="isExamSatisfied(examResults[scope.row.projectId + '_' + scope.row.role]) ? 'success' : 'danger'"
                    size="small">
                    {{ examResultTagText(examResults[scope.row.projectId + '_' + scope.row.role], true) }}
                  </el-tag>
                </template>
                <template v-else-if="scope.row.projectId && (scope.row.role === 'companyTrainer' || scope.row.role === 'practicalTrainer')">
                  <span style="color: #909399; font-size: 12px;">加载中...</span>
                </template>
                <template v-else>
                  <span style="color: #909399; font-size: 12px;">-</span>
                </template>
              </template>
            </el-table-column>

            <el-table-column label="操作" min-width="100" fixed="right">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="handleComplete(scope.row)">完成</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页组件 -->
          <el-pagination
            @size-change="handleTodoSizeChange"
            @current-change="handleTodoCurrentChange"
            :current-page="todoQuery.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="todoQuery.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="todoTotal">
          </el-pagination>
        </el-tab-pane>

        <!-- ==================== 已完成列表 Tab ==================== -->
        <el-tab-pane label="已完成" name="completed">
          <!-- 搜索栏 -->
          <div class="search-bar">
            <el-form :model="completedQuery" :inline="true" size="small" label-width="80px">
              <el-form-item label="关键字">
                <el-input
                  v-model="completedQuery.keyword"
                  placeholder="项目名称/客户名称"
                  clearable
                  @clear="getCompletedList"
                  @keyup.enter.native="getCompletedList"
                  style="width: 200px;">
                </el-input>
              </el-form-item>
              <el-form-item label="任务类型">
                <el-select
                  v-model="completedQuery.nodeCode"
                  placeholder="全部"
                  clearable
                  style="width: 150px;"
                  @change="getCompletedList">
                  <el-option label="公司培训" value="COMPANY_TRAINING_COMPLETE"></el-option>
                  <el-option label="实操培训" value="PRACTICAL_TRAINING_COMPLETE"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="培训师">
                <el-select
                  v-model="completedQuery.trainerId"
                  placeholder="全部"
                  clearable
                  style="width: 150px;"
                  @change="getCompletedList">
                  <el-option v-for="emp in employeeList" :key="emp._id" :label="emp.name" :value="emp._id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="完成日期">
                <el-date-picker
                  v-model="completedQuery.dateArray"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="getCompletedList"
                  style="width: 240px;">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getCompletedList">查询</el-button>
              </el-form-item>
            </el-form>
          </div>

          <!-- 已完成列表表格 -->
          <el-table :data="completedList" border stripe v-loading="completedLoading">
            <el-table-column type="index" label="#" width="50"></el-table-column>
            <el-table-column label="项目名称" min-width="200">
              <template slot-scope="scope">
                <div class="text-title">{{ scope.row.projectName || '-' }}</div>
                <div class="text-detail">{{ scope.row.customerName || '-' }}</div>
              </template>
            </el-table-column>
            <el-table-column label="预约时间" min-width="100">
              <template slot-scope="scope">
                {{ scope.row.startedAt | date }}
              </template>
            </el-table-column>
            <el-table-column label="完成时间" min-width="100">
              <template slot-scope="scope">
                {{ scope.row.completedAt | date }}
              </template>
            </el-table-column>
            <el-table-column label="签约人" min-width="100">
              <template slot-scope="scope">
                {{ scope.row.signerName || '-' }}
              </template>
            </el-table-column>
            <el-table-column label="签约品牌" min-width="100">
              <template slot-scope="scope">
                {{ scope.row.signType || '-' }}
              </template>
            </el-table-column>
            <el-table-column label="负责人" min-width="100">
              <template slot-scope="scope">
                <div class="text-content">
                  {{ scope.row.assigneeName || '-' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="任务类型" min-width="130">
              <template slot-scope="scope">
                <el-tag :type="scope.row.role === 'companyTrainer' ? 'primary' : 'success'" size="small">
                  {{ (scope.row.role === 'companyTrainer' ? '公司培训' : '实操培训') }}
                </el-tag>
              </template>
            </el-table-column>
            <!-- <el-table-column label="门店地址" min-width="200">
              <template slot-scope="scope">
                <div class="text-content">
                  {{ scope.row.province }}{{ scope.row.city }}{{ scope.row.district }}
                </div>
                <div class="text-detail">{{ scope.row.address || '-' }}</div>
              </template>
            </el-table-column> -->

            <el-table-column label="操作" min-width="100" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页组件 -->
          <el-pagination
            @size-change="handleCompletedSizeChange"
            @current-change="handleCompletedCurrentChange"
            :current-page="completedQuery.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="completedQuery.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="completedTotal">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- ========================================
         完成任务弹窗
         用于上传设计稿和填写备注
    ======================================== -->
    <el-dialog
      title="完成任务"
      :visible.sync="completeDialogVisible"
      width="600px"
      top="5vh"
      :close-on-click-modal="false"
      @closed="onCompleteDialogClosed">
      <el-form ref="completeFormRef" :model="completeForm" :rules="completeRules" label-width="100px">
        <!-- 项目名称（只读） -->
        <el-form-item label="项目名称">
          <span>{{ currentTask.projectName || '-' }}</span>
        </el-form-item>
        <!-- 任务类型（只读） -->
        <el-form-item label="任务类型">
          <el-tag :type="currentTask.role === 'companyTrainer' ? 'primary' : 'success'" size="small">
            {{ (currentTask.role === 'companyTrainer' ? '公司培训' : '实操培训') }}
          </el-tag>
        </el-form-item>

        <!-- 答题测试情况（公司培训和实操培训都显示） -->
        <el-form-item label="答题情况" v-if="currentExamResult !== null">
          <div v-if="currentExamResult.list.length === 0" style="color: #909399;">暂无答题记录</div>
          <div v-else ref="examResultCapture">
            <el-tag
              :type="isExamSatisfied(currentExamResult) ? 'success' : 'danger'"
              size="medium"
              style="margin-bottom: 10px;">
              {{ examResultTagText(currentExamResult, false) }}
            </el-tag>
            <el-table :data="currentExamResult.list" border size="mini" style="width: 100%;">
              <el-table-column prop="name" label="姓名"></el-table-column>
              <el-table-column label="最高分">
                <template slot-scope="scope">
                  <span :style="{ color: scope.row.passed ? '#67C23A' : '#F56C6C', fontWeight: 'bold' }">
                    {{ scope.row.score }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="是否通过">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.passed ? 'success' : 'danger'" size="mini">
                    {{ scope.row.passed ? '通过' : '未通过' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="提交时间" width="150">
                <template slot-scope="scope">
                  {{ scope.row.submitTime | dateFormat }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>

        <!-- 截图上传 -->
        <el-form-item label="截图" prop="images">
          <!-- 公司培训和实操培训都提供自动截图按钮 -->
          <div v-if="currentExamResult && currentExamResult.list.length > 0" style="margin-bottom: 10px;">
            <el-button type="success" size="small" icon="el-icon-camera" @click="captureAndUploadExamResult">
              自动截图答题结果
            </el-button>
            <span style="color: #909399; font-size: 12px; margin-left: 8px;">将自动截取上方答题结果</span>
          </div>
          <!-- 手动上传区域 -->
          <ImageUpload
            ref="imageUploadRef"
            v-model="completeForm.images"
            :active="completeDialogVisible"
            :show-tip="true"
            @preview="handleUploadPreview"
          />
        </el-form-item>

        <!-- 备注（选填） -->
        <el-form-item label="备注">
          <el-input
            v-model="completeForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入备注信息（选填）">
          </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="completeDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitComplete">提交</el-button>
      </span>
    </el-dialog>

    <!-- ========================================
         查看详情弹窗
         用于查看已完成任务的设计稿
    ======================================== -->
    <el-dialog
      title="查看详情"
      :visible.sync="detailDialogVisible"
      width="600px"
      :close-on-click-modal="false">
      <div v-if="currentDetail" class="detail-content">
        <!-- 基本信息 -->
        <el-descriptions :column="1" border size="small">
          <el-descriptions-item label="项目名称">
            {{ currentDetail.projectName || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="客户名称">
            {{ currentDetail.customerName || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="任务类型">
            <el-tag :type="currentDetail.role === 'companyTrainer' ? 'primary' : 'success'" size="small">
              {{ (currentDetail.role === 'companyTrainer' ? '公司培训' : '实操培训') }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="完成时间">
            {{ currentDetail.completedAt | date }}
          </el-descriptions-item>
        </el-descriptions>

        <!-- 设计稿展示 -->
        <div class="detail-section">
          <div class="detail-section-title">截图</div>
          <div class="detail-images" v-if="currentDetail.data && currentDetail.data.images && currentDetail.data.images.length > 0">
            <el-image
              v-for="(img, index) in currentDetail.data.images"
              :key="index"
              :src="base + img"
              :preview-src-list="currentDetail.data.images.map(i => base + i)"
              style="width: 100px; height: 100px; margin-right: 8px;"
              fit="cover">
            </el-image>
          </div>
          <div v-else class="detail-empty">暂无截图</div>
        </div>

        <!-- 备注展示 -->
        <div class="detail-section" v-if="currentDetail.data && currentDetail.data.remark">
          <div class="detail-section-title">备注</div>
          <div class="detail-remark">{{ currentDetail.data.remark }}</div>
        </div>
      </div>

      <span slot="footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 图片预览组件（隐藏） -->
    <el-image
      v-show="false"
      ref="imageViewer"
      :src="previewImageUrl"
      :preview-src-list="previewImageList">
    </el-image>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import ImageUpload from '@/components/ImageUpload.vue'

/**
 * 设计师工作台页面
 *
 * 功能说明：
 * 1. 显示培训师的待完成和已完成任务统计
 * 2. 待完成任务列表：显示分配给当前培训师的设计任务，支持上传截图完成
 * 3. 已完成任务列表：显示培训师已完成的设计任务历史，支持查看截图
 *
 * 培训师角色：
 * - companyTrainer: 公司培训师
 * - trainer: 实操培训师
 *
 * 数据来源：
 * - 后端API: /server-api/process/trainer/todo
 * - 后端API: /server-api/process/trainer/completed
 */
export default {
  name: 'Peixun',

  components: { ImageUpload },

  data () {
    return {
      // ==================== 状态数据 ====================
      activeTab: 'todo', // 当前激活的Tab页
      todoTotal: 0, // 待完成任务总数
      completedTotal: 0, // 已完成任务总数

      // ==================== 待完成列表相关 ====================
      todoQuery: {
        keyword: '', // 关键字搜索
        nodeCode: '', // 任务类型筛选
        trainerId: '', // 设计师ID筛选
        page: 1,
        pageSize: 20
      },
      todoList: [], // 待完成任务列表
      todoLoading: false, // 加载状态

      // ==================== 已完成列表相关 ====================
      completedQuery: {
        keyword: '',
        nodeCode: '', // 任务类型筛选
        trainerId: '', // 设计师ID筛选
        dateArray: [], // 日期范围筛选
        page: 1,
        pageSize: 20
      },
      completedList: [], // 已完成任务列表
      completedLoading: false,

      // ==================== 完成任务弹窗相关 ====================
      completeDialogVisible: false, // 弹窗可见性
      currentTask: {}, // 当前操作的任务
      completeForm: {
        images: [], // 上传的截图图片URL列表
        remark: '' // 备注
      },
      completeRules: {
        // 设计稿必填验证
        images: [
          {
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error('请上传截图'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      },
      submitLoading: false, // 提交按钮加载状态

      // ==================== 查看详情弹窗相关 ====================
      detailDialogVisible: false,
      currentDetail: null, // 当前查看的任务详情

      base: window.sessionStorage.getItem('base') || '', // 图片基础路径

      // ==================== 图片预览相关 ====================
      previewImageUrl: '',
      previewImageList: [],
      employeeList: [], // 培训师列表

      // ==================== 答题结果相关 ====================
      examResults: {}, // 以 projectId 为 key 的答题结果缓存
      currentExamResult: null // 当前弹窗中显示的答题结果
    }
  },

  /**
   * 生命周期钩子：组件创建时执行
   * 初始化数据并加载列表
   */
  created () {
    this.base = window.sessionStorage.getItem('base') || ''
    this.getEmployeeList()
    this.getTodoList()
    this.getCompletedList()
  },

  methods: {
    // ==================== 统计卡片点击处理 ====================
    /**
     * 统计卡片点击事件
     * @param {String} type - 点击的卡片类型：'todo' 或 'completed'
     */
    handleStatClick (type) {
      if (this.activeTab === type) return // 已是当前Tab，无需重复加载
      this.activeTab = type
      if (type === 'todo') {
        this.getTodoList()
      } else {
        this.getCompletedList()
      }
    },

    // ==================== Tab切换处理 ====================
    /**
     * Tab切换事件
     * @param {Object} tab - Tab组件实例
     */
    handleTabChange (tab) {
      if (tab.name === 'todo') {
        this.getTodoList()
      } else {
        this.getCompletedList()
      }
    },

    async getEmployeeList () {
      this.employeeList = []
      try {
        const { data: res } = await this.$http.get('process/getEmployeeList', {
          params: { role: 'trainer' }
        })
        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg)
          return
        }
        this.employeeList = res.data || []
      } catch (error) {
        console.error('获取培训师列表失败:', error)
        this.$message.error('获取培训师列表失败')
      }
    },

    // ==================== 待完成列表方法 ====================
    /**
     * 获取培训师待办任务列表
     * 调用后端API获取当前培训师的所有待完成设计任务
     */
    async getTodoList () {
      this.todoLoading = true
      try {
        const params = {
          keyword: this.todoQuery.keyword,
          nodeCode: this.todoQuery.nodeCode,
          trainerId: this.todoQuery.trainerId,
          page: this.todoQuery.page,
          pageSize: this.todoQuery.pageSize
        }

        const { data: res } = await this.$http.get('process/trainer/todo', { params })

        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg)
          return
        }

        this.todoList = res.data.list || []
        this.todoTotal = res.data.total || 0

        // 清空缓存，重新加载答题结果
        this.examResults = {}
        this.loadExamResults(this.todoList)
      } catch (error) {
        console.error('获取培训师待办任务失败:', error)
        this.$message.error('获取培训师待办任务失败')
      } finally {
        this.todoLoading = false
      }
    },

    /**
     * 待完成列表每页数量变更
     * @param {Number} val - 新的每页数量
     */
    handleTodoSizeChange (val) {
      this.todoQuery.pageSize = val
      this.getTodoList()
    },

    /**
     * 待完成列表页码变更
     * @param {Number} val - 新的页码
     */
    handleTodoCurrentChange (val) {
      this.todoQuery.page = val
      this.getTodoList()
    },

    // ==================== 已完成列表方法 ====================
    /**
     * 获取培训师已完成任务列表
     * 调用后端API获取当前培训师的所有已完成设计任务历史
     */
    async getCompletedList () {
      this.completedLoading = true
      try {
        const params = {
          keyword: this.completedQuery.keyword,
          nodeCode: this.completedQuery.nodeCode,
          trainerId: this.completedQuery.trainerId,
          page: this.completedQuery.page,
          pageSize: this.completedQuery.pageSize
        }

        // 日期范围处理
        if (this.completedQuery.dateArray && this.completedQuery.dateArray.length === 2) {
          params.startDate = this.completedQuery.dateArray[0]
          params.endDate = this.completedQuery.dateArray[1]
        }

        const { data: res } = await this.$http.get('process/trainer/completed', { params })

        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg)
          return
        }

        this.completedList = res.data.list || []
        this.completedTotal = res.data.total || 0
      } catch (error) {
        console.error('获取培训师已完成任务失败:', error)
        this.$message.error('获取培训师已完成任务失败')
      } finally {
        this.completedLoading = false
      }
    },

    /**
     * 已完成列表每页数量变更
     * @param {Number} val - 新的每页数量
     */
    handleCompletedSizeChange (val) {
      this.completedQuery.pageSize = val
      this.getCompletedList()
    },

    /**
     * 已完成列表页码变更
     * @param {Number} val - 新的页码
     */
    handleCompletedCurrentChange (val) {
      this.completedQuery.page = val
      this.getCompletedList()
    },

    // ==================== 完成任务相关方法 ====================
    /**
     * 打开完成任务弹窗
     * @param {Object} row - 当前行数据
     */
    async handleComplete (row) {
      this.currentTask = row
      this.completeForm = {
        images: [],
        remark: ''
      }
      this.currentExamResult = null
      this.completeDialogVisible = true

      // 公司培训和实操培训都加载答题结果
      if ((row.role === 'companyTrainer' || row.role === 'practicalTrainer') && row.projectId) {
        const trainingType = row.role === 'companyTrainer' ? 'company' : 'practical'
        const cacheKey = `${row.projectId}_${row.role}`
        try {
          // 先尝试从缓存取
          if (this.examResults[cacheKey]) {
            this.currentExamResult = this.examResults[cacheKey]
          } else {
            const { data: res } = await this.$http.get('tiku/record/summary', {
              params: { projectId: row.projectId, trainingType }
            })
            if (res.meta.status === 200) {
              this.currentExamResult = res.data
              this.$set(this.examResults, cacheKey, res.data)
            }
          }
        } catch (e) {
          console.error('获取答题结果失败:', e)
        }
      }
    },

    /**
     * 完成任务弹窗关闭后重置数据
     */
    onCompleteDialogClosed () {
      this.currentTask = {}
      this.completeForm = {
        images: [],
        remark: ''
      }
    },

    /**
     * 图片预览
     * @param {String} imageUrl - 预览的图片URL
     */
    handleUploadPreview (imageUrl) {
      if (imageUrl) {
        this.previewImageList = [imageUrl]
        this.previewImageUrl = imageUrl
        this.$nextTick(() => {
          this.$refs.imageViewer.clickHandler()
        })
      }
    },

    /**
     * 提交完成任务
     * 调用后端API完成设计任务
     */
    async submitComplete () {
      // 表单验证
      const valid = await this.$refs.completeFormRef.validate().catch(() => false)
      if (!valid) return

      // 公司培训和实操培训都需要验证答题结果
      if (this.currentExamResult) {
        if (this.currentExamResult.list.length === 0) {
          return this.$message.warning('暂无员工答题记录，无法完成')
        }
        const satisfied = this.isExamSatisfied(this.currentExamResult)
        if (!satisfied) {
          if (this.currentExamResult.passStrategy === 'one') {
            return this.$message.warning('暂无员工通过答题测试，至少需要一人通过才能完成')
          }
          const failedCount = this.currentExamResult.list.filter(r => !r.passed).length
          return this.$message.warning(`还有${failedCount}人未通过答题测试，所有人都通过后才能完成`)
        }
      }

      this.submitLoading = true
      try {
        // 构建请求数据
        const data = {
          nodeCode: this.currentTask.nodeCode,
          action: 'complete',
          data: {
            images: this.completeForm.images,
            remark: this.completeForm.remark
          }
        }

        // 调用后端API执行节点完成操作
        const { data: res } = await this.$http.post(
          `process/instances/${this.currentTask.instanceId}/execute`,
          data
        )

        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg)
          return
        }

        this.$message.success('任务完成成功')
        this.completeDialogVisible = false

        // 刷新列表
        this.getTodoList()
        this.getCompletedList()
      } catch (error) {
        console.error('提交失败:', error)
        this.$message.error('提交失败，请重试')
      } finally {
        this.submitLoading = false
      }
    },

    // ==================== 查看详情相关方法 ====================
    /**
     * 打开查看详情弹窗
     * @param {Object} row - 当前行数据
     */
    handleView (row) {
      this.currentDetail = row
      this.detailDialogVisible = true
    },

    // ==================== 答题结果相关方法 ====================
    /**
     * 判断答题结果是否满足完成条件（兼容旧后端无 satisfied 字段的情况）
     * @param {Object} result - 答题结果对象
     * @return {Boolean} 是否满足完成条件
     */
    isExamSatisfied (result) {
      if (!result) return false
      return result.satisfied !== undefined ? result.satisfied : result.allPassed
    },

    /**
     * 生成答题结果 tag 文案（区分列表和弹窗两种场景）
     * @param {Object} result - 答题结果对象
     * @param {Boolean} withTotal - 是否在文案中包含总人数（列表场景为 true，弹窗场景为 false）
     * @return {String} tag 文案
     */
    examResultTagText (result, withTotal) {
      if (!result || !result.list) return '-'
      const total = result.list.length
      const passedCount = result.list.filter(r => r.passed).length
      const failedCount = total - passedCount
      const satisfied = this.isExamSatisfied(result)
      const strategy = result.passStrategy || 'all'
      // 后缀：列表场景显示总人数，弹窗场景单独一行显示
      const suffix = withTotal ? `(${total}人)` : `（共${total}人）`
      if (satisfied) {
        if (strategy === 'one') {
          return `已通过${passedCount}${withTotal ? '/' + total : ''}${suffix}`
        }
        return `全部通过${suffix}`
      }
      // 未满足条件
      if (strategy === 'one') {
        return `无人通过${suffix}`
      }
      return `${failedCount}人未通过${suffix}`
    },

    /**
     * 批量获取待办列表中培训任务的答题结果
     * 公司培训和实操培训都加载
     */
    async loadExamResults (list) {
      for (const item of list) {
        // 公司培训和实操培训都需要加载答题结果
        if (item.role !== 'practicalTrainer' && item.role !== 'companyTrainer') continue
        if (!item.projectId) continue
        // 根据 role 确定培训类型
        const trainingType = item.role === 'companyTrainer' ? 'company' : 'practical'
        // 缓存 key 改为 projectId_role 复合形式
        const cacheKey = `${item.projectId}_${item.role}`
        // 避免重复请求
        if (this.examResults[cacheKey]) continue
        try {
          const { data: res } = await this.$http.get('tiku/record/summary', {
            params: { projectId: item.projectId, trainingType }
          })
          if (res.meta.status === 200) {
            this.$set(this.examResults, cacheKey, res.data)
          }
        } catch (e) {
          console.error('获取答题结果失败:', e)
        }
      }
    },

    /**
     * 自动截图答题结果并上传
     */
    async captureAndUploadExamResult () {
      if (!this.$refs.examResultCapture) {
        this.$message.warning('暂无答题结果可截图')
        return
      }

      try {
        // 截图
        const canvas = await html2canvas(this.$refs.examResultCapture, {
          backgroundColor: '#ffffff',
          scale: 2,
          useCORS: true
        })

        // 将 canvas 转为 Blob
        const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'))

        // 构建 FormData 上传
        const formData = new FormData()
        formData.append('file', blob, '答题结果截图.png')

        const { data: res } = await this.$http.post('upload', formData, {
          headers: {
            authorization: window.sessionStorage.getItem('token'),
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data'
          }
        })

        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg || '截图上传失败')
          return
        }

        // 通过 ImageUpload 组件的 addImageUrl 方法添加图片
        if (this.$refs.imageUploadRef) {
          this.$refs.imageUploadRef.addImageUrl(res.data.url, '答题结果截图.png')
        } else {
          // 如果组件引用不可用，直接修改数组
          this.completeForm.images.push(res.data.url)
        }

        this.$message.success('答题结果截图已上传')
      } catch (error) {
        console.error('自动截图失败:', error)
        this.$message.error('自动截图失败，请手动上传')
      }
    }
  }
}
</script>

<style lang="less" scoped>
// ==================== 统计卡片样式 ====================
.statistics-row {
  display: flex;
  gap: 20px;
  margin-top: 20px;
}

.stat-card {
  flex: 1;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .el-card__body {
    padding: 16px 20px;
  }
}

.stat-card-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;

  i {
    color: #fff;
  }
}

.wait-icon {
  background: linear-gradient(135deg, #409EFF, #66b1ff);
}

.finish-icon {
  background: linear-gradient(135deg, #67C23A, #95d475);
}

.stat-info {
  flex: 1;
}

.stat-number {
  font-size: 28px;
  font-weight: bold;
  color: #303133;
  line-height: 1.2;
}

.stat-label {
  font-size: 13px;
  color: #909399;
  margin-top: 4px;
}

// ==================== 搜索栏样式 ====================
.search-bar {
  margin-bottom: 15px;
}

// ==================== 分页样式 ====================
.el-pagination {
  margin-top: 15px;
}

// ==================== 文字样式 ====================
.text-title {
  font-size: 14px;
  font-weight: bold;
  color: #191a1a;
}

.text-content {
  font-size: 12px;
}

.text-detail {
  font-size: 10px;
  color: #909399;
}

// ==================== 上传提示样式 ====================
.upload-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 8px;
}

// ==================== 详情弹窗样式 ====================
.detail-content {
  .detail-section {
    margin-top: 20px;
  }

  .detail-section-title {
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    margin-bottom: 12px;
  }

  .detail-images {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .detail-empty {
    color: #909399;
    font-size: 14px;
  }

  .detail-remark {
    font-size: 14px;
    color: #606266;
    line-height: 1.6;
    padding: 10px;
    background: #f5f7fa;
    border-radius: 4px;
  }
}
</style>
